import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/img/brand/gtr-evolution-logo-color-on-dark.svg'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-md-9 col-lg-8 col-xl-6" }
const _hoisted_3 = { class: "card auth-form-card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-text" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = { class: "auth-error-message-box text-center rounded-bottom small mx-3 text-light" }
const _hoisted_9 = {
  key: 0,
  class: "bg-warning bg-opacity-50 p-2"
}
const _hoisted_10 = {
  key: 1,
  class: "bg-danger bg-opacity-50 p-2"
}
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = { class: "auth-error-message-box text-center rounded-bottom small mx-3 text-light" }
const _hoisted_14 = {
  key: 0,
  class: "bg-danger bg-opacity-50 p-2"
}
const _hoisted_15 = {
  key: 1,
  class: "bg-danger bg-opacity-50 p-2"
}
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = {
  key: 0,
  id: "capslock-on",
  class: "ms-2 mb-1 text-warning small"
}
const _hoisted_18 = { class: "input-group" }
const _hoisted_19 = ["type"]
const _hoisted_20 = { class: "auth-error-message-box text-center rounded-bottom small mx-3 text-light" }
const _hoisted_21 = {
  key: 0,
  class: "bg-danger bg-opacity-50 p-2"
}
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = { class: "auth-error-message-box text-center rounded-bottom small mx-3 text-light" }
const _hoisted_25 = {
  key: 0,
  class: "bg-danger bg-opacity-50 p-2"
}
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = { class: "input-group" }
const _hoisted_28 = {
  type: "text",
  class: "form-control",
  placeholder: "Patrocinador",
  "aria-label": "Patrocinador",
  id: "enroller"
}
const _hoisted_29 = { class: "px-2" }
const _hoisted_30 = { class: "form-check" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "fa-sharp fa-solid fa-spinner fa-spin"
}
const _hoisted_34 = { class: "card-footer" }
const _hoisted_35 = { class: "text-muted small text-center" }
const _hoisted_36 = {
  class: "modal fade",
  id: "invalid-Link-modal",
  ref: "invalidLinkModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "messageModalLabel",
  "aria-hidden": "true"
}
const _hoisted_37 = {
  class: "modal fade",
  id: "registration-conf-modal",
  tabindex: "-1",
  role: "dialog",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_38 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_39 = { class: "modal-content" }
const _hoisted_40 = { class: "modal-footer justify-content-between" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "fa-sharp fa-solid fa-spinner fa-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          role: "form",
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
          novalidate: ""
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text-center auth-brand-wrap" }, [
                _createElementVNode("img", {
                  class: "auth-brand-logo",
                  src: _imports_0,
                  alt: "Genera tu Riqueza"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["text-center mb-2", { 'd-none': _ctx.devHelpersHidden }])
                }, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generarUsuario && _ctx.generarUsuario(...args))),
                    class: "btn btn-outline-info"
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "fa-sharp fa-solid fa-hat-wizard" }, null, -1)
                  ]))])
                ], 2),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fa-sharp fa-solid fa-envelope fa-fw" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", {
                      'is-invalid': _ctx.emailValidation.hasError,
                    }]),
                      placeholder: "Correo electrónico",
                      "aria-label": "Correo electrónico",
                      id: "email",
                      ref: "email",
                      autocomplete: "username",
                      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateEmailInput())),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registrationForm.email) = $event))
                    }, null, 34), [
                      [
                        _vModelText,
                        _ctx.registrationForm.email,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.emailValidation.hasWarning)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-circle fa-fw me-2 text-warning" }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.emailValidation.hasError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw me-2 text-danger" }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "auth-note text-center small mb-1" }, [
                    _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-circle fa-fw text-warning" }),
                    _createTextVNode(" El nombre de usuario no podrá ser modificado. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fa-sharp fa-solid fa-user fa-fw" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", {
                      'is-invalid': _ctx.invalidUsername || !_ctx.usernameAvailable,
                    }]),
                      placeholder: "Nombre de Usuario",
                      "aria-label": "Nombre de Usuario",
                      autocomplete: "nickname",
                      id: "username",
                      ref: "username",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registrationForm.username) = $event)),
                      onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateUsernameInput()))
                    }, null, 34), [
                      [
                        _vModelText,
                        _ctx.registrationForm.username,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (!_ctx.usernameAvailable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw me-2 text-danger" }, null, -1),
                          _createTextVNode("El nombre de usuario no está disponible. ", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.invalidUsername)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw me-2 text-danger" }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.usernameValidation.userMessage), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.capsLockOn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("span", { class: "small" }, [
                          _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw me-1" }),
                          _createTextVNode(" BloqMayús (CapsLock) está activado. ")
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fa-sharp fa-solid fa-lock fa-fw" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.showPassword ? 'text' : 'password',
                      class: _normalizeClass(["form-control", {
                      'is-invalid': !_ctx.validPassword,
                    }]),
                      placeholder: "Contraseña",
                      "aria-label": "Contraseña",
                      autocomplete: "new-password",
                      id: "password",
                      ref: "password",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registrationForm.password) = $event)),
                      onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validatePasswords()))
                    }, null, 42, _hoisted_19), [
                      [
                        _vModelDynamic,
                        _ctx.registrationForm.password,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-secondary pt-1",
                      type: "button",
                      id: "show-password",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa-sharp fa-solid fa-xs fa-fw", _ctx.showPassword ? 'fa-eye-slash' : 'fa-eye'])
                      }, null, 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (!_ctx.validPassword)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw me-2 text-danger" }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.passwordValidation.userMessage), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fa-sharp fa-solid fa-lock fa-fw" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: _normalizeClass(["form-control", {
                      'is-invalid': !_ctx.validPasswordConfirm,
                    }]),
                      placeholder: "Confirmar Contraseña",
                      "aria-label": "Confirmar Contraseña",
                      autocomplete: "new-password",
                      id: "confirmPassword",
                      ref: "confirmPsw",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.registrationForm.passwordConfirm) = $event)),
                      onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validatePasswords()))
                    }, null, 34), [
                      [
                        _vModelText,
                        _ctx.registrationForm.passwordConfirm,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    (!_ctx.validPasswordConfirm)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[28] || (_cache[28] = [
                          _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw me-2 text-danger" }, null, -1),
                          _createTextVNode("Las contraseñas no coinciden. ", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[29] || (_cache[29] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fa-sharp fa-solid fa-user-circle fa-fw" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.registrationForm.enroller), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "chkAgreeTerms",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.registrationForm.acceptTerms) = $event))
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        _ctx.registrationForm.acceptTerms,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[30] || (_cache[30] = _createElementVNode("label", {
                      class: "form-check-label text-light",
                      for: "flexCheckDefault"
                    }, " Acepto los Términos y Condiciones, así como el Acuerdo de Distribuidor. ", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.doRegister())),
                    class: "btn btn-primary mt-4 w-100",
                    disabled: 
                    _ctx.invalidFields() || _ctx.loading || !_ctx.emailOK || !_ctx.usernameOK
                  
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.buttonLabel) + " ", 1),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_32)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, {
                    class: "auth-link",
                    to: "/login"
                  }, {
                    default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                      _createTextVNode(" Ingresar ", -1),
                      _createElementVNode("i", { class: "fa-sharp fa-solid fa-user" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [...(_cache[33] || (_cache[33] = [
      _createStaticVNode("<div class=\"modal-dialog modal-dialog-centered\" data-v-a98b7e98><div class=\"modal-content\" data-v-a98b7e98><div class=\"modal-header bg-danger bg-gradient text-light py-2\" data-v-a98b7e98><h5 class=\"modal-title\" data-v-a98b7e98><i class=\"fa-sharp fa-solid fa-exclamation-triangle fa-fw me-2\" data-v-a98b7e98></i> Liga Inválida </h5></div><div class=\"modal-body text-center\" data-v-a98b7e98><p class=\"text-center text-warning\" data-v-a98b7e98><i class=\"fa-sharp fa-solid fa-exclamation-triangle fa-4x\" data-v-a98b7e98></i></p><p data-v-a98b7e98> Comuníquese con un socio para que le proporcione una liga de registro válida. </p></div></div></div>", 1)
    ]))], 512),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _cache[35] || (_cache[35] = _createStaticVNode("<div class=\"modal-header bg-secondary py-2 bg-gradient text-light\" data-v-a98b7e98><h5 class=\"modal-title\" data-v-a98b7e98><i class=\"fa-sharp fa-solid fa-flag-checkered fa-fw me-2\" data-v-a98b7e98></i>Registro Exitoso </h5></div><div class=\"modal-body\" data-v-a98b7e98><div class=\"text-center mt-2 mb-4\" data-v-a98b7e98><h5 data-v-a98b7e98>Bienvenido a la familia <strong data-v-a98b7e98>GTR Evolution!</strong></h5></div><p data-v-a98b7e98> Hemos enviado una liga para verificar tu correo electrónico a la dirección que registraste. Favor de revisar tu bandeja de entrada y y darle click al botón para activar todas las funciones de tu cuenta. </p><p data-v-a98b7e98>Ya puedes acceder a tu plataforma desde este momento.</p></div>", 2)),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.gotoLoginPage()))
            }, " Inicio "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.refreshPage()))
            }, [...(_cache[34] || (_cache[34] = [
              _createElementVNode("i", { class: "fa-sharp fa-solid fa-redo fa-fw" }, null, -1)
            ]))]),
            _createElementVNode("button", {
              class: "btn btn-outline-primary",
              "data-bs-target": "#verificationModal",
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
              disabled: _ctx.loading
            }, [
              _createTextVNode(_toDisplayString(_ctx.verifyModalButtonLabel) + " ", 1),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("i", _hoisted_42))
                : _createCommentVNode("", true)
            ], 8, _hoisted_41)
          ])
        ])
      ])
    ])
  ], 64))
}